import { PLANK_IS_SHOWN, PLANK_IS_HIDDEN } from '../actionTypes/plank';

export const showPlank = () => ({
    type: PLANK_IS_SHOWN
});

export const hidePlank = () => ({
    type: PLANK_IS_HIDDEN
});
